'use client';

import { memo } from 'react';
import useMediaQuery from '@mui/material/useMediaQuery';
import Grid from '@mui/material/Grid';
import ProductCard from '@components/Cards/ProductCard';
import Section from '@repo/ui/src/components/Section';
import useProducts from '@hooks/product/useProducts';

import type { ProductModelProps } from '@typings/product';

interface RecommendedProductsClientProps {
  saleText?: string;
  newText?: string;
  outOfStockText?: string;
  _data?: Array<ProductModelProps>;
}

const RecommendedProductsClient = memo(function RecommendedProductsClient({
  saleText,
  newText,
  _data,
  outOfStockText,
}: RecommendedProductsClientProps) {
  const smAndUp = useMediaQuery((theme: any) => theme.breakpoints.up('sm'));
  const { products } = useProducts(_data);

  return (
    <Section texture gutterX={!!smAndUp}>
      <div className="flex flex-col md:flex-row items-stretch pb-6 md:pb-20">
        <Grid container>
          {products?.length > 0 &&
            products.map((product) => (
              <Grid
                item
                key={product?.sku}
                xs={12}
                sm={6}
                lg={3}
                className="border border-warm-200"
              >
                <ProductCard
                  product={product}
                  saleText={saleText}
                  newText={newText}
                  outOfStockText={outOfStockText}
                />
              </Grid>
            ))}
        </Grid>
      </div>
    </Section>
  );
});

export default RecommendedProductsClient;
